module.exports = function (bootstrap) {
    bootstrap.directive('clientSiteHeader', ["modal", "navigation", "appId", "brand", "services", "session", "sessionData", "$state", "$cookies", "coremetrics", "teamsite", "brandConfig", "$compile", "invisibleForm", "storage", "brandValues",
        function (modal, navigation, appId, brand, services, session, sessionData, $state, $cookies, coremetrics, teamsite, brandConfig, $compile, invisibleForm, storage, brandValues) {
            return {
                replace: true,
                scope: {},
                template: require('directives/hmhs/clientHeader.html'),
                controller: ["$scope", "$rootScope", "$q", "coremetrics", "teamsite", "invisibleForm", "brandConfig", "session", "sessionData", "storage", "brandValues", function ($scope, $rootScope, $q, coremetrics, teamsite, invisibleForm, brandConfig, session, storage, brandValues) {


                    var getUbkFromBrand = function (brand) {
                        switch (brand) {
                            case 'unbrandedhm':
                                return 3001;
                            //case 'hmhs':
                            //    return 3001;
                            case 'ibccr':
                                return 3002;
                            case 'mincr':
                                return 3003;
                            case 'healthco':
                                return 3004;
                            case 'hmhs':
                                return 0;
                        }

                    };

                    var getBrandFromUbk = function (ubk) {
                        ubk = ubk.toString();
                        switch (ubk) {
                            case '3001':
                                return 'unbrandedhm';
                            case '3002':
                                return 'ibccr';
                            case '3003':
                                return 'mincr';
                            case '3004':
                                return 'healthco';
                            case '0':
                                return 'hmhs';
                        }
                    };


                    var getBrandNameFromUbk = function (ubk) {
                        switch (ubk) {
                            case '3001':
                                return 'Highmark';
                            case '3002':
                                return 'Independence Blue Cross';
                            case '3003':
                                return 'Minnesota';
                            case '3004':
                                return 'Health Co';

                            case '0':
                                return 'HM Health Solutions';
                        }
                    };

                    //focus hamburger menu for mobile screen
                    $(window).resize(function () {
                        var browserZoomLevel = Math.round(((window.outerWidth - 10) / window.innerWidth) * 10) * 10;
                        if (browserZoomLevel >= 150) {
                            document.getElementById("mobile-menu").focus();
                        }
                    });

                    document.addEventListener('keyup', function (e) {
                        if (e.keyCode === 27) {//close hamburger on pressing Esc 
                            $scope.showMenu = false;
                            $scope.mobileMenuToggle = 'hide-mobile-menu';
                            $scope.$digest();
                        }
                    });


                    //highlight Active menu item
                    var setActiveMenu = function () {
                        if ($scope.navigation.headerTabs) {
                            // console.log(" $scope.navigation", $scope.navigation);
                            var state = $state;
                            // console.log("state", state);
                            $scope.selectedTabText = '';
                            if (state && $scope.navigation.headerTabs) {
                                for (var i = 0; i < $scope.navigation.headerTabs.length; i++) {
                                    if ($scope.navigation.headerTabs[i].state === state.current.data.activeTab) {
                                        $scope.navigation.headerTabs[i].active = true;
                                    }
                                    else {
                                        $scope.navigation.headerTabs[i].active = false;
                                    }
                                }
                               // console.log('HeaderTabs===>', $scope.navigation.headerTabs);
                            }

                        }
                    }

                    $scope.$watch(function () {
                        return sessionData.userEntitlements;
                    }, function (newValue, oldValue) {

                        var curBr = getBrandNameFromUbk($cookies.get('ubkKey'));
                        if (newValue && newValue.companies) {
                            $scope.currentBrand = newValue.companies[curBr].brandKey;
                            //Scoping to Show Brand Dropdown if $scope.role = 'Executive Reviewer';
                            $scope.role = session.data.userEntitlements.role;
                            $scope.adminDropdownCount = 0;
                            angular.forEach(newValue.companies, function () {
                                $scope.adminDropdownCount++;
                            });
                        }
                        //needs to be done post login
                        /*
                        if(navigation.data.avatar && navigation.data.avatarService[0].url){
                            services.clxptl.avatar().getUserAvatar().then(function(response){
                                sessionData.userEntitlements.updateAvatar = false;
                                if(response.data){
                                    $scope.imageSrc = navigation.data.avatarService[0].url;
                                }else{
                                    $scope.imageSrc = false;
                                }
                            });
                        }else{
                                $scope.imageSrc= false;
                        }
                        */

                        $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
                            if (newUrl.indexOf('highmarkbcbsde.com/employer/clients') != -1) {
                                $scope.isClientsPage = true;
                                $scope.isChangePassword = false;
                            }
                            else if (newUrl.indexOf('highmarkbcbsde.com/employer/pa-change-password') != -1) {
                                $scope.isChangePassword = true;
                            }
                            else {
                                $scope.isClientsPage = false;
                                $scope.isChangePassword = false;
                            }
                            setActiveMenu($state);

                        });
                        $scope.$on('$stateChangeSuccess', function (event, toState/*, toParams, fromState, fromParams*/) {
                            // $scope.navopen = false;
                            setActiveMenu($state);
                        });

                        if (navigation.data.avatarService && navigation.data.avatarService[0] && navigation.data.avatarService[0].imageSrc != "default") {
                            services.clxptl.avatar().getUserAvatar().then(function (response) {
                                sessionData.userEntitlements.updateAvatar = false;
                                if (response.data) {
                                    $scope.imageSrc = "/clxptl/x-services/secure/user/avatar";
                                } else {
                                    $scope.imageSrc = $scope.btsRegion + "bootstrap/v4/resources/img/hmhs/defaultAvatar.png";
                                }
                            });
                        } else {
                            $scope.imageSrc = $scope.btsRegion + "bootstrap/v4/resources/img/hmhs/defaultAvatar.png";
                        }


                    }, true);


                    $scope.changeBrand = function (brandKey) {


                        brand.override = getBrandFromUbk(brandKey);
                        var brandName = getBrandNameFromUbk(brandKey.toString());
                        //$cookies.put('ubkKey', getUbkFromBrand(branding));
                        $cookies.put('ubkKey', brandKey);
                        $scope.currentBrand = sessionData.userEntitlements.companies[brandName].brandKey;
                        brandConfig.update();
                        navigation.update();

                        coremetrics.postPasswordClientStart();
                        $rootScope.$broadcast('brandChange', []);
                        $scope.$broadcast('brandChange', []);
                        //$state.reload();
                        $state.transitionTo($state.current, null, {
                            reload: true, inherit: true, notify: true
                        });

                    };
                }],

                link: function ($scope, element) {
                    var getBrandNameFromBrand = function (ubk) {
                        switch (ubk) {
                            case 'unbrandedhm':
                                return 'Highmark';
                            case 'ibccr':
                                return 'Independence Blue Cross';
                            case 'mincr':
                                return 'Minnesota';
                            case 'healthco':
                                return 'Health Co';
                        }
                    };
                    //Prepopulate Company dropdown to 'Highmark' if user has Multi Company View entitlement.
                    $scope.brandData = brand.current;
                    $scope.navigation = navigation.data;
                    $scope.session = session.data;
                    $scope.showMobileMenu = false;
                    $scope.mobileMenuToggle = 'hide-mobile-menu';
                    $scope.mobileUserToggle = 'hide-mobile-userMenu';
                    $scope.userData = session.data.userInfo;
                    $scope.adminRights = $scope.session.userInfo;
                    $scope.mode = "client";

                    $scope.showMobileMenu = function () {
                        if ($scope.showMenu) {
                            $scope.showMenu = false;
                            $scope.mobileMenuToggle = 'hide-mobile-menu';
                        } else {
                            $scope.showMenu = true;
                            $scope.mobileMenuToggle = 'show-mobile-menu';
                        }
                    };

                    $scope.showUserOptions = function () {
                        if ($scope.showUserMenu) {
                            $scope.showUserMenu = false;
                            $scope.mobileUserToggle = 'hide-mobile-userMenu';
                        } else {
                            $scope.showUserMenu = true;
                            $scope.mobileUserToggle = 'show-mobile-userMenu';
                            /**/
                        }
                    };

                    var nDotPos = window.location.hostname.indexOf('.');
                    $scope.subdomain = (window.location.hostname.substring(nDotPos - 5, nDotPos));
                    $scope.btsRegion = 'https://static' + $scope.subdomain + '.hmhs.com/';
                    if ($scope.subdomain.indexOf('denv') == -1 && $scope.subdomain.indexOf('tenv') == -1) {
                        $scope.subdomain = 'Production';
                        $scope.btsRegion = 'https://static.hmhs.com/';
                    }

                    if ($scope.subdomain == 'Production') {
                        $scope.region = 'https://static.hmhs.com/';
                    } else {
                        $scope.region = 'https://static' + $scope.subdomain + '.hmhs.com/';
                    }

                    $scope.logout = function () {
                        var keysToRemove = ["switch", "currentBrand", "currentUbk", "footerbrandLogo", "multiBrand", "targetBrand", "targetUbk", "tempBrand", "tempUbk"];
                        for (key in keysToRemove) {
                            storage.del(keysToRemove[key]);
                        }
                        session.logoutWithRedirect();
                    };
                    /*Switch Brand */
                    $scope.switchBrand = function () {
                        storage.set("switch", "true");
                        location.reload();
                        storage.set("tempBrand", storage.get("currentBrand"));
                        storage.set("currentBrand", storage.get("targetBrand"));
                        storage.set("targetBrand", storage.get("tempBrand"));
                        storage.set("tempUbk", storage.get("currentUbk"));
                        storage.set("currentUbk", storage.get("targetUbk"));
                        storage.set("targetUbk", storage.get("tempUbk"));
                    };
                    /*Switch Brand  ends*/

                    (function configureForEmployer() {
                        if (appId && appId.toLowerCase() === 'eprweb') {
                            $scope.isEmployer = true;
                            $scope.multiBrand = false;

                            if (!storage.get("switch")) {
                                storage.set("switch", "false");
                            }

                            /*brand selection  starts*/
                            $scope.$watch(function () {
                                return sessionData.basicInfo;
                            }, function () {
                                if (sessionData.basicInfo) {
                                    loginId = sessionData.basicInfo.loginId;
                                    services.eprsvc.brandSelection().fetch(loginId).then(function (response) {
                                        var obj = response.data.payload;
                                        if (response.data && response.data.payload.length == 2) {
                                            $scope.multiBrand = true;
                                            storage.set("multiBrand", "true");
                                            //finding mulitbrand brand details                                            
                                            angular.forEach(obj, function (value, key) {
                                                if (value.brandId === $cookies.get('emkt_ubk')) {
                                                    $scope.parentBrand = value.vendorName;
                                                    $scope.parentUbk = value.brandId;
                                                } else {
                                                    $scope.targetBrand = value.vendorName;
                                                    $scope.targetUbk = value.brandId;
                                                }
                                            });

                                            if (storage.get("switch") === "false") {
                                                storage.set("currentBrand", $scope.parentBrand)
                                                storage.set("targetBrand", $scope.targetBrand)
                                                storage.set("currentUbk", $scope.parentUbk)
                                                storage.set("targetUbk", $scope.targetUbk)
                                            }

                                            //finding Brand logo
                                            $scope.$watch(function () {
                                                return brandValues;
                                            }, function () {
                                                if (brandValues) {
                                                    angular.forEach(brandValues.brandInfo, function (value, key) {
                                                        if (value.ubk === parseInt(storage.get("currentUbk")) && value.ubk != undefined) {
                                                            console.log(value.logoImg)
                                                            $scope.multibrandLogo = value.logoImg;
                                                        }
                                                    })

                                                }
                                            })
                                        } else {
                                            $scope.multiBrand = false;
                                            storage.set("multiBrand", "false");
                                        }
                                    })
                                }
                            });
                            /*brand selection  ends*/

                            services.eprsvc.volatile().fetch().then(function (response) {
                                var loginDate = new Date(response.data.payload.lastLoginDate);
                                var nMonth = loginDate.getMonth() + 1;
                                var nYear = loginDate.getFullYear();
                                var nDate = loginDate.getDate();
                                var nHours = loginDate.getUTCHours();
                                var AMPM = (nHours >= 12) ? "PM" : "AM";
                                var nMins = loginDate.getUTCMinutes();
                                var nMin = (nMins < 10) ? '0' + nMins : nMins;
                                var fullDateTime = nMonth + "/" + nDate + "/" + nYear + " " + nHours + ":" + nMin + " " + AMPM;
                                $scope.lastLogin = fullDateTime;
                            });

                            services.rbsmbl.basicInfo().fetch().then(
                                function (response) {
                                    if (response && response.data && response.data.payload && response.data.payload.basicInfo) {

                                        var actualRole = response.data.payload.basicInfo.actualRole;
                                        var splitURL = window.location.hostname.split('.');
                                        var subdomain = splitURL[0];
                                        var domain = splitURL[1];
                                        var cookieDomain = '.' + domain + '.com';
                                        $scope.isRoleSBA = response.data.payload.basicInfo.role === 'SBA';
                                        $scope.SBA = response.data.payload.basicInfo.actualRole === 'SBA';
                                        $scope.isSBA = actualRole === 'SBA';
                                        $scope.isProducer = actualRole === 'AGENT' || actualRole === 'AGENCY_ADMIN';

                                        if ($scope.isSBA) {
                                            $scope.goToClients = function () {
                                                $cookies.remove('multiClientID', { path: '/', domain: cookieDomain });
                                                $scope.isSBA = false;
                                                $scope.isRoleSBA = true;
                                                $scope.SBA = false;
                                                $state.go('clients');
                                            };
                                        }
                                        if ($scope.isProducer) {
                                            $scope.isProducer = true;

                                            var producerSubdomain = subdomain.toLowerCase() === 'www'
                                                ? 'producer'
                                                : 'producer' + subdomain;


                                            var producerDomain = (domain.toLowerCase() === 'mybenefitshome' || domain.toLowerCase() === 'highmarkbcbs' || domain.toLowerCase() === 'highmarkblueshield' || domain.toLowerCase() === 'highmarkbcbsde')
                                                ? 'highmark'
                                                : domain;

                                            var producerURL =
                                                'https://' + producerSubdomain + '.' + producerDomain + '.com/#!/clients/clientsEmployerLogin';

                                            $scope.goToProducer = function () {
                                                $cookies.remove('multiClientID', { path: '/', domain: cookieDomain });
                                                $scope.isProducer = false;
                                                window.location.href = producerURL;
                                            };
                                        }
                                    }
                                }
                            );
                        }
                    }());
                }


            };
        }]);

};
